import { Validation } from "../../../../../interfaces/common";
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES, Regex, MaxLength } from "../../../../../utils/appConstant";
import { AddEdit as AddEditInterface } from "../../../../../interfaces/customer.interface";

export const validateAddEditForm = (formData: AddEditInterface, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.customerName) {
    if(!formData.customerName?.trim()) { 
      validations.validate = false; 
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.customerName, message: APP_ERROR_MESSAGES.customers.addEdit.blankCustomerName }) 
    } else if (formData.customerName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.customerName, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryFirstName) {
    if (!formData.primaryFirstName?.trim()) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryFirstName, message: APP_ERROR_MESSAGES.customers.addEdit.blankPrimaryFirstName })
    } else if (formData.primaryFirstName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryFirstName, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryLastName) {
    if (!formData.primaryLastName?.trim()) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryLastName, message: APP_ERROR_MESSAGES.customers.addEdit.blankPrimaryLastName })
    } else if (formData.primaryLastName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryLastName, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryEmail) {
    if (!formData.primaryEmail?.trim()) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryEmail, message: APP_ERROR_MESSAGES.customers.addEdit.blankPrimaryEmail })
    } else if (!Regex.email.test(formData.primaryEmail.trim())) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.primaryEmail, message: APP_ERROR_MESSAGES.customers.addEdit.invalidPrimaryEmail })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.secondaryEmail) {
    if (formData.secondaryEmail?.trim()) {
      const emails = formData.secondaryEmail
        .split(';')
        .map(e => e.trim())
        .filter(e => e.length > 0);

      const invalidEmail = emails.find(email => !Regex.email.test(email));

      if (invalidEmail) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.secondaryEmail,
          message: APP_ERROR_MESSAGES.customers.addEdit.invalidSecondaryEmail
        });
      }
    }
  }


  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.displayName) {
    if (!formData.displayName?.trim()) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.displayName, message: APP_ERROR_MESSAGES.customers.addEdit.blankDisplayName })
    } else if (formData.displayName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.displayName, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryPhone) {
    if (!formData.primaryPhone?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryPhone,
        message: APP_ERROR_MESSAGES.customers.addEdit.blankPhoneNumber,
      });
    } else if (formData.primaryPhone.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryPhone,
        message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.companyName) {
    if (formData.companyName?.trim() && formData.companyName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.companyName, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.website) {
    if (formData.website?.trim() && formData.website.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.website, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }


  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.hstNo) {
    if (formData.hstNo?.trim() && formData.hstNo.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.hstNo, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.billingCurrency) {
    if (!formData.billingCurrency) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.billingCurrency, message: APP_ERROR_MESSAGES.customers.addEdit.blankBillingCurrency })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.billingAddress1) {
    if (formData.billingAddress1?.trim() && formData.billingAddress1.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.billingAddress1, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.billingAddress2) {
    if (formData.billingAddress2?.trim() && formData.billingAddress2.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.billingAddress2, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.billingPostal) {
    if (formData.billingPostal?.trim() && formData.billingPostal.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.billingPostal, message: APP_ERROR_MESSAGES.customers.addEdit.maxLengthExceeded })
    }
  }
  return validations;
};